import React from 'react';
import styled from 'styled-components';
import { LinkTranslatedProps, StyledButtonProps } from '@contracts';
import Colors from './Colors';
import LinkTranslated from './LinkTranslated';
import { ButtonStyleTemplate } from './SharedStyles';

interface LinkButtonProps extends LinkTranslatedProps {
  size?: 'small-round' | 'small' | 'normal' | 'large';
  children: React.ReactNode;
  textColor?: string;
  backgroundColor?: string;
  borderRadius?: string;
  isInline?: boolean;
}

const LinkButton: React.FC<LinkButtonProps> = ({
  size = 'normal',
  href = '#',
  textColor,
  backgroundColor,
  borderRadius = '5px',
  isInline = false,
  children,
  ...props
}) => (
  <LinkButtonStyle
    to={href}
    $size={size}
    $buttonTextColor={textColor}
    $backgroundColor={backgroundColor}
    $borderRadius={borderRadius}
    $isInline={isInline}
    {...props}
  >
    {children}
  </LinkButtonStyle>
);

export default LinkButton;

const LinkButtonStyle = styled(LinkTranslated)<StyledButtonProps>`
  ${ButtonStyleTemplate}
`;

export const LinkButtonSecondary = styled(LinkButton)`
  background: ${Colors.paleGold};
  color: ${Colors.forestGreen};
`;
